import React from 'react';
import { SelfTestQuestion } from './model/SelfTestQuestion';
import { UrlService } from '../../core/services/UrlService';
import { toast } from "react-toastify";

type Props = {
    id: string,
    q: SelfTestQuestion;
    onAnswerClicked: (answer?: string) => any;
}

const SelfTestTemplateBMIQuestionContext: React.FC<Props> = (props: Props) => {
    const [state, setState] = React.useState({
        weight: '',
        height: '',
    });
    const [BMI, setBMI] = React.useState<string>(null);
    const [BMIGroup, setBMIGroup] = React.useState<string>(null);

    const onInputchange = (event) => {
        setState({
            weight: state.weight,
            height: state.height,
            ...{
                [event.target.name]: event.target.value
            }
        });
    }

    const handleClick = (ev: any) => {
        props.onAnswerClicked(`${BMI}`);
    }

    const calcBMI = () => {
        if (props.q.expr && state.weight && state.height) {
            try {
                const bmi = parseFloat(state.weight) / (parseFloat(state.height) * parseFloat(state.height) / 10000);
                if (bmi < 0 || bmi > 100) {
                    throw Error();
                }
                setBMI(bmi.toFixed(2));
                setBMIGroup(props.q.expr(bmi));
                return;
            } catch (e) {
                
            }
        }
        toast("請輸入正確的身高/體重。");
    };

    const shouldButtonDisable = React.useMemo(() => {
        return BMI === null;
    }, [BMI]);

    return (
        <div id={props.id} className={`self-test__test-question self-test__test-question-bmi q${props.id}`}>
            <div className="self-test__test-question-sizer">
                <div className="self-test__test-question-cover">
                    <div className="self-test__test-question-cover-bmi">
                        <img src={UrlService.getLocalImageUrl(props.q.image ?? "placeholder.png")} alt="" />
                        <div className="self-test__test-bmi-description">
                            <p>
                                *BMI值計算公式:
                            </p>
                            <p>
                                BMI = 體重(公斤) / 身高<sup>2</sup>(公尺<sup>2</sup>)
                            </p>
                        </div>
                        <div className="self-test__test-bmi-description">
                            <p>
                                **BMI（Body Mass Index）
                            </p>
                            <p>
                                是用來評估體重是否理想和衡量肥胖程度的指標。
                            </p>
                        </div>
                    </div>
                </div>
                <div className="self-test__test-question-content">
                    <div className="self-test__test-question-pre-description-container"></div>
                    <p className="title" dangerouslySetInnerHTML={{ __html: props.q.title ?? "" }}></p>
                    <p className="content" dangerouslySetInnerHTML={{ __html: props.q.content ?? "" }}></p>

                    <div className="self-test__test-bmi-question-panel">
                        <div className="__group">
                            <div className="__group-item">
                                <label>
                                    體重
                                </label>
                                <div className="__input-group">
                                    <input
                                        name='weight'
                                        type='number'
                                        value={state.weight}
                                        onChange={onInputchange}
                                    />
                                    <div className="__unit">
                                        <p>
                                            千克 / 公斤 (kg)
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="__group-item">
                                <label>
                                    身高
                                </label>
                                <div className="__input-group">
                                    <input
                                        name='height'
                                        type='number'
                                        value={state.height}
                                        onChange={onInputchange}
                                    />
                                    <div className="__unit">
                                        <p>
                                            厘米 / 公分 (cm)
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="__group-item">
                                <label>
                                    &nbsp;
                                </label>
                                <div className="__input-group transparent">
                                    <button onClick={calcBMI}>計算BMI指數</button>
                                </div>
                            </div>
                        </div>

                            <div className="__result">
                                {
                                    BMI && BMIGroup &&
                                    <div className="__result-text">
                                        您BMI指標為 <span className="__important">{BMI}</span>, 屬於 <span className="__important">{BMIGroup}</span>
                                    </div>
                                }
                            </div>
                        <div className="__reference">
                            <div className="__reference-text">
                                {
                                    props.q.answers?.map((x, index) => {
                                        return (
                                            <div>
                                                {x.answer}  :  {x.label}
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="self-test__test-bmi-question-next">
                        <button className="self-test__button primary" onClick={handleClick} disabled={shouldButtonDisable}>
                            {props.q.btnText ?? '下一題'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelfTestTemplateBMIQuestionContext;
